/**
 * The pool you were last looking at, remembered across screens that have no
 * pool in their URL — the guide, the account page, the console.
 *
 * The URL stays the source of truth wherever there is one (`VesselRoute`);
 * this is only what the top bar's links point at from everywhere else, so
 * "Now" on the guide page goes back to the pool you came from.
 */
const KEY = "poolnerd-last-vessel";

export function rememberVessel(id: number): void {
  try {
    localStorage.setItem(KEY, String(id));
  } catch {
    // Storage can be unavailable; the bar then falls back to the first pool.
  }
}

export function rememberedVessel(): number | null {
  try {
    const raw = localStorage.getItem(KEY);
    const id = raw === null ? NaN : Number(raw);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}
